import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PreviewCardProps as Props } from './types';

export const PreviewCard = memo(
  ({ className, title, description, tooltipContent, children }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('PreviewCard', className)}
        sx={SX.root}
      >
        <Stack
          sx={SX.header}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {title && <Typography sx={SX.title}>{title}</Typography>}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            gap={1}
          >
            {description && (
              <Typography sx={SX.description}>{description}</Typography>
            )}
            {tooltipContent && (
              <Tooltip title={tooltipContent}>
                <Icon name="info" sxx={SX.tooltipIcon} size={18} />
              </Tooltip>
            )}
          </Stack>
        </Stack>
        <Box>{children}</Box>
      </Styled.Wrapper>
    );
  }
);

PreviewCard.displayName = 'PreviewCard';
